module.exports = __webpack_public_path__ + "static/media/banesco-provider.637b02fa.svg";